import Home from "./components/Home.vue"

export const routes = [
    { path: '', component: Home, name: 'Home' },
  ];